import { message } from "antd";

import { getUserToken } from "./appUtils";
import { isTokenExpired } from "./jwtUtils";
import { clearAuthAndRedirect } from "./tokenRefresh";

const configureApi = (API, addLocation) => {
  // Request Interceptor which handles token refresh pre and post token expiry
  API.interceptors.request.use(
    (config) => {
      const accessToken = getUserToken();
      if (addLocation) {
        config.headers.X_LOCATION_CODE = JSON.parse(window.localStorage.getItem("location"))?.code || "AU_VIC_MEL";
      }
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  const responseSuccessHandler = (response) => response.data;

  const responseErrorHandler = async (error) => {
    // Handle 401 - Check if token is actually expired
    if (error.response?.status === 401) {
      const accessToken = getUserToken();

      // Only logout if the token is actually expired
      // If token is still valid, it's a permission/role issue, not a session issue
      if (isTokenExpired(accessToken)) {
        message.error({ content: "Session expired. Please log in again.", duration: 2 });
        clearAuthAndRedirect();
      }
      // For permission-based 401s (token not expired), don't show session expired message
      // Let the caller handle the error appropriately
      return Promise.reject(error);
    }

    // Handle other errors
    if (error.response?.status === 400 || error.response?.status === 404 || error.response?.status === 500) {
      message.error({
        content:
          error.response?.data?.description || error.response?.data?.message || "some error occured, please try again",
        duration: 2
      });
    }

    return Promise.reject(
      new Error({
        status: error.response?.status,
        error: error.response?.data
      })
    );
  };

  API.interceptors.response.use(
    (response) => responseSuccessHandler(response),
    (error) => responseErrorHandler(error)
  );

  return API;
};

export default configureApi;
